//
import { keyframes } from '@emotion/core';
import { cards } from './cards.styles';
import { flipCard } from './flipCard.styles';
import { rating } from './rating.styles';
import { matching } from './matching.styles';
import { clickAndReveal } from './clickAndReveal.styles';
import { focusBorder } from './variables';
import { laBallPulse } from './la-ball-pulse';
//

export const fader = keyframes`
from {
	opacity: 0;
}
to {
	opacity: 1;
}
`;

export const globalStyles = `

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;

		&::-webkit-scrollbar {
			width: 5px;
		}
		
		&::-webkit-scrollbar-track {
			background-color: lightgrey;
		}
		
		&::-webkit-scrollbar-thumb {

			background-color: darkgrey;
		}

		-webkit-tap-highlight-color: transparent;
	}
	
	html, body {
		width: 100%;
		height: 100%;

	}

	body {
		font-family: 'Poppins', sans-serif;
		font-weight: 300;
		overflow-anchor: none;
	}

	h1, h2, h3, h4 {
		font-weight: 200;
	}

	p strong {
		font-weight: 700 !important;
	}

	strong {
		font-weight: 700 !important;
	}

	input[type=text] {
		font-weight: 300;
	}

	img {
		align-self: center;
		vertical-align: bottom;
		max-width: 100%;
		flex-shrink: 0;
	}

	form {
		width: 100%;
	}

	#root {
		width: 100%;
		height: 100%;
	}

	.chameleon-text {
		width: 100%;

		overflow-wrap: break-word;
		word-wrap: break-word;
		word-break: break-word;

		p, li {
			

		}

		p span {
		}
	}

	h1, h2, h3, h4 {

		li {
			margin-left: .5em;
		}

		ol {
			position: relative;
			left: .5em;
		}

		ol li:before {
	
			padding-left: 10px !important;
		}

	}

	p,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	strong, 
	em, 
	u {
		max-width: 100%;
	}


	.fader_-2s {
		animation: ${fader} 0.2s forwards;
	}

	.fader_-5s {
		animation: ${fader} 0.5s forwards;
	}

	.fader_1s {
		animation: ${fader} 1s forwards;
	}

	button {
		font-family: inherit !important;
	}

	input {
		:focus {
			border: ${focusBorder};
		}
	}

	textarea {
		:focus {
			border: ${focusBorder};
		}
	}

	.wtf {
		border: 10px solid green;
			}



	pre {
		display: flex;
		padding: 0 !important;
		border: none !important;
	}

	code {
		display: inline;
		padding: 10px 20px 20px 10px !important;
		border-radius: 3px;
		background: #eaeffb;
	}

	*:focus {
		outline: none;
	}

	a:link {
		color: #0000EE;
	}

	a:visited {
	}

	a:hover {
		text-decoration: none;
	}

	a:active {
		color: red;
	}


	a:focus {
	}

	.center-text {
		text-align: center;
	}

	.chameleon-text-align-left, [data-type="textAlignLeft"] {
		text-align: left;

		ul, ol {
			list-style-position: outside !important;		
		}
	}

	.chameleon-text-align-center, [data-type="textAlignCenter"] {
		text-align: center;

		ul, ol {
			list-style-position: inside;		
		}

		> ul, > ol {
			display: inline-block;
			margin-left: 0px !important;
		}

	}

	.chameleon-text-align-right, [data-type="textAlignRight"] {
		text-align: right;

		ul, ol {
			list-style-position: inside;		
		}
	
		> ul, > ol {
			display: inline-block;
			margin-left: 0px;
		}
	  
	}

	.text-align-center {
		text-align: center;
	}

	// https://gist.github.com/ffoodd/000b59f431e3e64e4ce1a24d5bb36034
	.sr-only {
		border: 0 !important;
		clip: rect(1px, 1px, 1px, 1px) !important; 
		-webkit-clip-path: inset(50%) !important;
			clip-path: inset(50%) !important;  
		height: 1px !important;
		margin: -1px !important;
		overflow: hidden !important;
		padding: 0 !important;
		position: absolute !important;
		width: 1px !important;
		white-space: nowrap !important;            
	}

	.visually-hidden {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip-path: inset(50%);
		white-space: nowrap;
		border: 0;
	}

	.lang-bracket::before {
		content: '[';
		 color: rgb(64, 64, 64);
	}

	.lang-bracket::after {
		content: ']';
		 color: rgb(64, 64, 64);
	}

	${cards}
	${flipCard}
	${rating}
	${matching}
	${clickAndReveal}

	${laBallPulse}

@keyframes open-nav-topic-menu {
	from {
		height: 0px;
	}
	to {
		height: calc-size(auto, size);
	}
}

@keyframes close-nav-topic-menu {
	from {
		height: calc-size(auto, size);
	}
	to {
		height: 0px;
	}
}

@keyframes _slideIn_ {
	0% {
		opacity: 0;
		transform: translateX(-100%);
	}

	35% {
		opacity: 0;
		transform: translateX(-100%);
	}

	100% {
		opacity: 1;
		transform: translateX(0%);
	}
}

@keyframes _slideOut_ {
	0% {
		opacity: 1;
		transform: translateX(0%);
	}

	15% {
		opacity: 1;
		transform: translateX(5%);
	}

	100% {
		opacity: 0;
		transform: translateX(-100%);
	}
}

.navigation-menu-slide-in {
	animation: _slideIn_ 0.75s forwards;
}

.navigation-menu-slide-out {
	animation: _slideOut_ 0.5s forwards;
}

@keyframes _image-edit-wrapper-frame-selected_ {
  from {
    width: 50%;
    height: 50%;
  }
  to {
    width: 75%;
    height: 75%;
  }
}

.image-edit-wrapper-frame-selected {
animation: _image-edit-wrapper-frame-selected_ 0.2s forwards
}

@keyframes image-edit-wrapper-frame-not-selected {
from {
  width: 75%;
  height: 75%;
}
to {
  width: 50%;
  height: 50%;
}
}

`;
